import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';

export const StyledNamesContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    gap: '16px',
    marginTop: '12px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexDirection: 'column',
    },
  };
});
